import gql from 'graphql-tag';

import { AddressFields } from '../../casa/AddressFields';
import { CommonDateFields } from '../../common/CommonDateFields';

export const MaintenanceRequestFields = gql`
  fragment MaintenanceRequestFields on OdProtosWebData_MaintenanceRequest {
    id
    state
    kind
    costCents
    vendorBranch {
      id
      displayName
    }
    scheduledOn {
      ...CommonDateFields
    }
    completedOn {
      ...CommonDateFields
    }
    address {
      ...AddressFields
    }
    frequency {
      frequencyKind
      frequencyAmount
    }
    approvalFeedback
    denialFeedback
    beforePhotosCount
    afterPhotosCount
    onsiteWorker {
      token
      fullName
      members {
        uuid
        roles {
          identifier
        }
      }
    }
  }

  ${CommonDateFields}
  ${AddressFields}
`;
